import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { SuggestionState } from '../types';
import type { Disposable } from '@patsnap/tahiti-core';

export const SuggestionModel = Symbol('SuggestionModel');

export interface SuggestionModel extends AbstractModel<SuggestionState>, Disposable { }
